class CartDrawerItems extends HTMLElement {
    constructor() {
      super();

      this.cartForm = this.querySelector('form');
      this.submitButton = this.cartForm.querySelector('[type="submit"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.eventRemoveFromCart = new Event('remove_from_cart');

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);
  
      this.addEventListener('change', this.debouncedOnChange.bind(this));
      this.cartForm.addEventListener('submit', this.handleSubmit.bind(this));

    }

    connectedCallback(){
      this.addEventListener('variant-b2b-cart-change', e => {
       this.updateB2bItems(e.detail.target.id.replace('CartItem-', ''), e.detail.updates);
      });
    }

    handleSubmit(event) {
      if (this.submitButton.classList.contains('loading')) return;
      event.preventDefault();
      document.dispatchEvent(new Event('begin_checkout'));
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      setTimeout(() => {
        this.submitButton.click();
      }, 750);
    }

    onChange(event) {
        if(event.target.classList.contains('variant-input-b2b')) { return; }
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }

    getSectionsToRender() {
        return [
          {
            section: 'cart',
            id: 'cart-drawer',
            selector: '.cart-drawer',
          },
          {
            section: 'header',
            id: 'cart-icon',
            selector: '#cart-icon'
          }
        //   {
        //     id: 'cart-icon',
        //     section: 'cart-icon',
        //     selector: '.shopify-section'
        //   }
        ];
      }

    clearCart() {

      const body = JSON.stringify({
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_clear_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.cartDrawer.renderContents(parsedState);
          this.disableLoading();
        }).catch(() => {
          this.disableLoading();
        });
    }

    updateB2bItems(line, updates) {
      this.enableLoading(line);

      const body = JSON.stringify({
        updates: updates,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      fetch(`/cart/update.js`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          // this.classList.toggle('is-empty', parsedState.item_count === 0);
          // const cartFooter = document.getElementById('main-cart-footer');

          // if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

          this.cartDrawer.renderContents(parsedState);

          // this.getSectionsToRender().forEach((section => {
          //   const elementToReplace =
          //     document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          //   elementToReplace.innerHTML =
          //     this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          // }));

          // this.updateLiveRegions(line, parsedState.item_count);
          // const lineItem =  document.getElementById(`CartItem-${line}`);
          // if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
          this.disableLoading();

        }).catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          // document.getElementById('cart-errors').textContent = window.cartStrings.error;
          this.disableLoading();
        });
    }

    updateQuantity(line, quantity, name) {
        this.enableLoading(line);

        if (quantity === 0) {
          try {
            const itemDataLayer = JSON.parse(document.querySelector(`#CartItem-${line} [data-item-data-layer]`).innerHTML);
            if (itemDataLayer) {
              this.eventRemoveFromCart.payload = itemDataLayer;
              document.dispatchEvent(this.eventRemoveFromCart);
            }
          } catch (error) { }
        }
        
        const body = JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        });
    
        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            this.cartDrawer.renderContents(parsedState);
            this.disableLoading();
          }).catch(err => {
            console.log(err);
            this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
            this.disableLoading();
          });
      }

      removeBundle(line, keys) {
          this.enableLoading(line);

          try {
            const itemDataLayer = JSON.parse(document.querySelector(`#CartItem-${line} [data-item-data-layer]`).innerHTML);
            if (itemDataLayer) {
              this.eventRemoveFromCart.payload = itemDataLayer;
              document.dispatchEvent(this.eventRemoveFromCart);
            }
          } catch (error) { }

          const updates = {};

          keys.split(',').forEach(key => {
            updates[key] = 0;
          });

          const body = JSON.stringify({
            updates: updates,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
          });
      
          fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              const parsedState = JSON.parse(state);
              this.cartDrawer.renderContents(parsedState);
              this.disableLoading();
            }).catch(err => {
              console.log(err);
              this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
              this.disableLoading();
            });
        }

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      if (document.getElementById('cart-drawer-items')) {
        document.getElementById('cart-drawer-items').classList.add('cart-drawer-line-items--disabled');
        this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
      }
      // document.activeElement.blur();
      // this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading() {
      document.getElementById('cart-drawer-items').classList.remove('cart-drawer-line-items--disabled');
    }
    
}

customElements.define('cart-drawer-items', CartDrawerItems);


class CartCountdown extends HTMLElement {
  constructor() {
    super();
    this.cartDrawer = document.querySelector('cart-drawer');
    this.cartDrawerItems = document.querySelector('cart-drawer-items');
    this.countdownPlaceholder = this.querySelector('[data-countdown]');
    this.cookieName = this.getAttribute('data-countdown-cookie-name');
    this.duration = parseFloat(this.getAttribute('data-duration'));
    this.durationInMilliseconds = this.duration * 60 * 1000;
    this.currentTime = new Date();
    this.currentUnixTime = Date.parse(this.currentTime);
    this.initializeClock();
  }
  initializeClock() {
    if(this.cartDrawer.getCookie(this.cookieName) != '') {
      this.lastAddedUnixTime = Date.parse(this.cartDrawer.getCookie(this.cookieName));
      this.deadline = new Date(this.lastAddedUnixTime + this.durationInMilliseconds);
      this.updateClock();
      this.timeinterval = setInterval(this.updateClock.bind(this), 1000);
      return;
    }
    this.cartDrawerItems.clearCart();
  }
  updateClock() {
    const t = this.getTimeRemaining();
    const minutes = ('0' + t.minutes).slice(-2);
    const seconds = ('0' + t.seconds).slice(-2);
    this.countdownPlaceholder.innerHTML = `${minutes}:${seconds} ${window.cartStrings.minutes}`;
    if (t.total <= 0) {
      clearInterval(this.timeinterval);
      this.cartDrawerItems.clearCart();
    }
}
  getTimeRemaining() {
      const total = Date.parse(this.deadline) - Date.parse(new Date());
      const seconds = Math.floor( (total/1000) % 60 );
      const minutes = Math.floor( (total/1000/60) % 60 );
      return { total, minutes, seconds };
  }
  restartClock() {
    this.countdownPlaceholder.innerHTML = '';
    this.currentTime = new Date();
    this.currentUnixTime = Date.parse(this.currentTime);
    this.deadline = new Date(this.currentUnixTime + this.durationInMilliseconds);
    this.initializeClock();
  }
  setLastAddedTimestamp() {
    this.setCookie(this.cookieName, new Date().toISOString(), 30 * 24 * 60) // 30 days in minutes
    this.restartClock();
  }
}

customElements.define('cart-countdown', CartCountdown);